import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AutoComplete from 'material-ui/AutoComplete';
import { MenuItem } from 'material-ui';

import api from 'services';

class OpenPositionAutoComplete extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ports: [],
            openPosition: props.openPosition,
            key: props.key,
            error: props.error,
        };

        this.dAutocomplete = _.debounce((searchText) => {
            if (searchText.length <= 2) {
                return;
            }

            api.findPortAdmin({ name: searchText, withAreas: true })
                .then((response) => {
                    const ports = [];

                    response.data.data.forEach((port) => {
                        ports.push(...this.createPort(port));
                    });

                    this.setState({
                        ports,
                    });
                })
                .catch(() => null);
        }, 1000);

        this.changeAutoComplete = this.changeAutoComplete.bind(this);
        this.chooseAutoComplete = this.chooseAutoComplete.bind(this);
    }

    createPort(port) {
        const ports = [];
        let name = '';

        if (port.sub) {
            port.sub.forEach((subPort) => {
                ports.push({
                    item: subPort,
                    text: `${subPort.name} - country ${port.country.name}`,
                    value: (
                        <MenuItem
                            primaryText={`${subPort.name} - country ${port.country.name}`}
                            value={subPort}
                            style={{ paddingLeft: '30px' }}
                        />
                    ),
                });
            });
        }

        if (port.country) {
            name = `${port.name} - country ${port.country.name}`;
        } else {
            name = port.name;
        }

        return [
            {
                item: port,
                text: name,
                value: (
                    <MenuItem
                        primaryText={name}
                        value={port}
                    />
                ),
            },
            ...ports,
        ];
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            openPosition: nextProps.openPosition,
            key: nextProps.key,
            error: nextProps.error,
        });
    }

    changeAutoComplete(searchText) {
        const { openPosition } = this.state;
        openPosition.namePort = searchText;

        this.setState({
            openPosition,
        }, () => {
            this.dAutocomplete(searchText);
        });
    }

    chooseAutoComplete(updateProperties) {
        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        const { openPosition } = this.state;

        openPosition.where = updateProperties.item._id;
        openPosition.namePort = updateProperties.item.name;

        this.setState({
            openPosition,
        }, () => {
            const { portKey } = this.props;

            this.props.changeOpenPosition(
                portKey,
                openPosition,
            );
        });
    }

    render() {
        const { openPosition, ports, error } = this.state;

        return (
            <div className='column-left half'>
                <div className='label'>{openPosition.where}</div>
                <AutoComplete
                    errorText={error}
                    textFieldStyle={{ fontSize: '13px' }}
                    hintText='Port'
                    searchText={openPosition.namePort}
                    dataSource={ports}
                    onUpdateInput={this.changeAutoComplete}
                    onNewRequest={this.chooseAutoComplete}
                    filter={AutoComplete.noFilter}
                    listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                    menuStyle={{ width: 'auto' }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                />
            </div>
        );
    }
}

export default connect(
    (state, {
        openPosition, error, portKey, changeOpenPosition, 
    }) => ({
        openPosition,
        error,
        portKey,
        changeOpenPosition,
    }),
    dispatch => bindActionCreators({ }, dispatch),
)(OpenPositionAutoComplete);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/AutoComplete.jsx